<script setup lang="ts">
import {IonContent, IonIcon, IonPopover} from "@ionic/vue";
import {informationCircleOutline} from "ionicons/icons";

const props = defineProps({
    label: {
        type: String,
        required: false,
        default: 'Details anzeigen'
    },
    inline: {
        type: Boolean,
        required: false,
        default: false
    },
    textOnly: {
        type: Boolean,
        required: false,
        default: false
    },
    side: {
        type: String,
        required: false,
        default: 'top'
    }
})

const rng = Math.round(Math.random()*100000000)

</script>

<template>
    <p :id="`overlay-trigger-${rng}`" class="globalTextLink" :class="{'inline': inline}">
        <IonIcon v-if="!textOnly" :icon="informationCircleOutline"  class="globalTextAlignedIcon" style="margin-right: 0.2em" />
        {{label}}&nbsp;&#8250;
    </p>

    <ion-popover :trigger="`overlay-trigger-${rng}`" trigger-action="click" :side="side" style="--width:85vw">
        <ion-content class="ion-padding">
            <slot/>
        </ion-content>
    </ion-popover>
</template>

<style scoped lang="scss">
p.globalTextLink {
    
    font-size: 1em;
    font-weight: var(--custom-font-weight-bold);
    color: var(--ion-color-red);

    &.inline {
        display: inline;
    }
}
</style>
